import "../css/footer.css";

function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/J3rkStore/reactoringo"
        target="_blank"
        rel="noreferrer"
        className="link-card github"
      >
        <p className="link-card">o</p>
      </a>
      <a
        href="https://www.linkedin.com/in/taran-leu-8230021a3/"
        target="_blank"
        rel="noreferrer"
        className="link-card linkedin"
      >
        <p className="link-card">o</p>
      </a>
    </footer>
  );
}

export default Footer;
